import { CoreState, Settings, Sources } from '@/store/core/state';
import { Mutations } from 'vuex-smart-module';
import { ValidatedConfig } from '@/entities/config';
import { AppInitData, DealerResponse, WebsiteResponse } from '@/types/core';

export class CoreMutations extends Mutations<CoreState> {
	toggleModal(payload?: void) {
		this.state.isModalOpen = !this.state.isModalOpen;
	}

	openPopup(payload?: void) {
		this.state.isModalOpen = true;
	}

	closePopup(payload?: void) {
		this.state.isModalOpen = false;
	}

	setInitData(data: AppInitData) {
		this.state.initData = data;
	}

	loadConfig(config: ValidatedConfig) {
		this.state.config = config;
	}

	loadStyleVariables(variables: StyleVariables) {
		this.state.styleVariables = variables;
	}

	randomColor(payload?: void) {
		this.state.styleVariables = { ...this.state.styleVariables, '--pp-primary-color': `#${Math.trunc(Math.random() * 1000000)}` };
	}

	setSettingsLoaded(payload?: void) {
		this.state.settingsLoaded = true;
	}

	unsetSettingsLoaded(payload?: void) {
		this.state.settingsLoaded = false;
	}

	saveSettings(settings: Partial<Settings>) {
		this.state.settings = { ...this.state.settings, ...settings };
	}

	setClientId(id: string) {
		this.state.clientId = id;
	}

	updateWebsite(website: WebsiteResponse) {
		this.state.website = website;
	}

	updateDealer(dealer: DealerResponse) {
		this.state.dealer = dealer;
	}

	saveWebsiteSettings(websiteSettings: Partial<Settings>) {
		this.state.websiteSettings = { ...this.state.websiteSettings, ...websiteSettings };
	}

	setError() {
		this.state.isError = true;
	}

	setOriginSource(source: Sources) {
		this.state.originSource = source;
	}
}
